import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  Button, Typography, Box
} from '@mui/material';
import { Warning, Delete, Info, CheckCircle } from '@mui/icons-material';

const icons = {
  warning: <Warning color="warning" sx={{ fontSize: 48 }} />,
  delete: <Delete color="error" sx={{ fontSize: 48 }} />,
  info: <Info color="info" sx={{ fontSize: 48 }} />,
  success: <CheckCircle color="success" sx={{ fontSize: 48 }} />
};

const ConfirmDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = 'Confirmar acción', 
  message = '¿Estás seguro de que deseas continuar?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  confirmColor = 'primary',
  type = 'warning',
  loading = false,
  children
}) => {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {icons[type]}
          <Typography variant="h6">{title}</Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        {children ? children : <DialogContentText>{message}</DialogContentText>}
      </DialogContent>
      
      <DialogActions sx={{ p: 2, pt: 0, gap: 1 }}>
        <Button onClick={onClose} disabled={loading} variant="outlined" color="inherit">
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm} 
          disabled={loading} 
          variant="contained" 
          color={confirmColor}
          autoFocus
        >
          {loading ? 'Procesando...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;